import { allPersonalityTypes } from './taxonomy';

export type VisualAsset = {
  typeId: string;
  hero: string;
  badge: string;
  primary: string;
  secondary: string;
};

const accentPairs = [
  ['var(--color-electric-blue)', 'var(--color-signal-green)'],
  ['var(--color-hot-pink)', 'var(--color-warning-yellow)'],
  ['var(--color-coral-red)', 'var(--color-electric-blue)'],
  ['var(--color-violet)', 'var(--color-warning-yellow)'],
  ['var(--color-signal-green)', 'var(--color-coral-red)'],
  ['var(--color-ink)', 'var(--color-hot-pink)']
] as const;

export const visualAssets: Record<string, VisualAsset> = Object.fromEntries(
  allPersonalityTypes.map((type, index) => {
    const [primary, secondary] = accentPairs[index % accentPairs.length];
    return [
      type.typeId,
      {
        typeId: type.typeId,
        hero: `/assets/characters/${type.typeId}/hero.svg`,
        badge: `/assets/characters/${type.typeId}/badge.svg`,
        primary,
        secondary
      }
    ];
  })
);
